<template>
  <div class="add-check-list pad">

    <div class="flex">
      <h2 class="title is-4 flex-1">New Pre-Start Check List</h2>
      <button class="button is-info is-small" @click="back">back</button>
    </div>

    <check-list-form @submitted="back" />
  </div>
</template>

<script>
import CheckListForm from '@/components/CheckListForm'
export default {
  name: 'AddCheckList',
  components: {
    CheckListForm
  },
  methods: {
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>

</style>
